import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLadaComponent } from './simple-icons-lada.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLadaComponent ],
    exports:      [ SimpleIconsLadaComponent ],
    bootstrap:    []
})
export class SimpleIconsLadaModule {}
